import { i18n } from "@/i18n";

const getNumberLocale = () => {
  return i18n.global.locale.value === "en" ? "en-US" : "ru-RU";
};

const getMonthNames = (): string[] => {
  const months = i18n.global.tm("format.monthsGenitive");
  return Array.isArray(months) ? (months as string[]) : [];
};

export const formatPhone = (paramValue: string) => {
  return paramValue.replace(
    /^(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/,
    "+$1 ($2) $3 $4-$5"
  );
};

export const formatAmountInput = (amount: number | string) => {
  if (typeof amount === "number") {
    return amount.toLocaleString(getNumberLocale());
  } else if (!isNaN(Number(amount)) && amount) {
    return Number(amount).toLocaleString(getNumberLocale());
  } else {
    console.log(i18n.global.t("format.errors.nonNumericType"));
    return "";
  }
};

export const formatDate = (inputDate: string) => {
  const months = getMonthNames();

  if (inputDate === null) {
    return "";
  } else {
    const date = new Date(inputDate);
    const day = date.getDate();
    const monthIndex = date.getMonth();

    return `${day} ${months[monthIndex] ?? ""}`.trim();
  }
};

export const convertKBToGB = (kilobytes: number) => {
  const kbInGB = Math.pow(1024, 2); // 1 GB in KB
  return Math.round(kilobytes / kbInGB);
};

export const formatPhoneNumber = (phone: number | string): string => {
  const phoneStr = String(phone).replace(/\D/g, "");

  if (phoneStr.length !== 11 || !phoneStr.startsWith("7")) {
    return i18n.global.t("format.errors.invalidPhoneNumber");
  }

  return `+7 (${phoneStr.slice(1, 4)}) ${phoneStr.slice(4, 7)} ${phoneStr.slice(
    7,
    9
  )}-${phoneStr.slice(9, 11)}`;
};
